import { CirclePlay, CircleStop, Loader2 } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

// Botão de timer play/stop padronizado — design Figma node-id 7126-258382
// Verde #34A853 (play) / Vermelho #E41F2B (stop), ícones circulares do lucide,
// 28px (md, padrão) ou 24px (sm), sombra exata do Figma.
export interface TimerToggleButtonProps {
  running: boolean;
  busy?: boolean;
  disabled?: boolean;
  onToggle: () => void;
  /** sm = 24px (listas densas), md = 28px (padrão) */
  size?: 'sm' | 'md';
  title?: string;
  className?: string;
}

export function TimerToggleButton({
  running,
  busy = false,
  disabled = false,
  onToggle,
  size = 'md',
  title,
  className,
}: TimerToggleButtonProps) {
  const isDisabled = disabled || busy;
  const sizeClass = size === 'sm' ? 'size-6' : 'size-7';
  const iconSize = size === 'sm' ? 14 : 20;
  const loaderSize = size === 'sm' ? 12 : 16;
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={isDisabled}
      title={title ?? (running ? 'Parar cronômetro' : 'Iniciar cronômetro')}
      aria-label={running ? 'Parar cronômetro' : 'Iniciar cronômetro'}
      className={cn(
        'flex shrink-0 items-center justify-center rounded-xl',
        running ? 'bg-danger-solid text-on-danger' : 'bg-success-solid text-on-success',
        isDisabled
          ? 'cursor-not-allowed opacity-60'
          : 'cursor-pointer shadow-[0px_1px_2px_rgba(0,0,0,0.1),0px_1px_1px_rgba(0,0,0,0.06)] transition-transform active:scale-95',
        sizeClass,
        className,
      )}
    >
      {busy ? (
        <Loader2 size={loaderSize} className="animate-spin" />
      ) : running ? (
        <CircleStop size={iconSize} />
      ) : (
        <CirclePlay size={iconSize} />
      )}
    </button>
  );
}
